// import React, { useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { authenticate } from "../actions/authActions";
// import { Box, Card, Container, Typography } from "@mui/material";
// import LoadingButton from "@mui/lab/LoadingButton";
// import PhoneInput from "react-phone-input-2";
// import "react-phone-input-2/lib/style.css";
// import imge from "../assets/hom.gif";
// import { useNavigate } from "react-router-dom";

// const LoginPage = () => {
//   const [phoneNumber, setPhoneNumber] = useState("");
//   const dispatch = useDispatch();
//   const { loading, error } = useSelector((state) => state.auth);
//   const navigate = useNavigate();


//   const handleSubmit = () => {
//     const trimmedPhoneNumber = phoneNumber.trim();
    
//     // Create both formats for validation
//     let phoneWithPlus, phoneWithoutPlus;
    
//     if (trimmedPhoneNumber.startsWith('+')) {
//       phoneWithPlus = trimmedPhoneNumber;
//       phoneWithoutPlus = trimmedPhoneNumber.slice(1);
//     } else {
//       phoneWithPlus = '+' + trimmedPhoneNumber;
//       phoneWithoutPlus = trimmedPhoneNumber;
//     }
  
//     // Check if either format is valid
//     if (!phoneWithoutPlus.startsWith('94')) {
//       alert("Please enter a valid phone number starting with +94 or 94.");
//       return;
//     }
  
//     // Try validating with original input format first
//     dispatch(authenticate(trimmedPhoneNumber))
//       .then((response) => {
//         if (response.success) {
//           navigate("/verify", { 
//             state: { 
//               phoneNumber: trimmedPhoneNumber,
//               sentOtp: response.data 
//             }
//           });
//         } else {
//           // If first attempt fails, try the alternate format
//           const alternateFormat = trimmedPhoneNumber.startsWith('+') ? 
//             trimmedPhoneNumber.slice(1) : '+' + trimmedPhoneNumber;
            
//           dispatch(authenticate(alternateFormat))
//             .then((altResponse) => {
//               if (altResponse.success) {
//                 navigate("/verify", { 
//                   state: { 
//                     phoneNumber: trimmedPhoneNumber, // Keep original format for display
//                     sentOtp: altResponse.data 
//                   }
//                 });
//               } else {
//                 alert("Invalid phone number. Please try again.");
//               }
//             });
//         }
//       })
//       .catch((err) => console.error("Unexpected error:", err));
//   };
  
//   return (
//     <Container
//     sx={{
//       display: "flex",
//       flexDirection: "column",
//       justifyContent: "center",
//       alignItems: "center",
//       minHeight: "100vh",
//       backgroundColor: "#F8F9FA",
//       backgroundImage: `url(${imge})`,
//       backgroundSize: "cover",
//       backgroundPosition: "center",
//       backgroundRepeat: "no-repeat",
//       padding: 2,
//       position: "absolute",
//       top: 0,
//       left: 0,
//       right: 0,
//     }}
//   >
//       <Card sx={{ borderRadius: 5, boxShadow: 8, padding: 4, maxWidth: 400,  }}>
//         <Box textAlign="center" mb={2}>
//           <Typography variant="h4" fontWeight={600}>
//             Sign in
//           </Typography>
//           <Typography variant="subtitle1" color="textSecondary" mt={1}>
//             Enter Your Registered Mobile Number
//           </Typography>
//         </Box>

//         <Box mb={3}>
//           <PhoneInput
//             country={"lk"}
//             value={phoneNumber}
//             onChange={(phone) => setPhoneNumber(phone)}
//             inputStyle={{
//               width: "100%",
//               paddingLeft: "60px",
//               borderRadius: 3,
//               fontSize: 16,
//             }}
//             buttonStyle={{
//               position: "absolute",
//               left: "9px",
//               top: "50%",
//               transform: "translateY(-50%)",
//             }}
//           />
//         </Box>

//         <Box>
//           <LoadingButton
//             onClick={handleSubmit}
//             loading={loading}
//             variant="contained"
//             sx={{
//               width: "100%",
//               backgroundColor: "#0049AF",
//               textTransform: "capitalize",
//               borderRadius: 3,
//             }}
//           >
//             <span style={{ color: "#fff", fontSize: 16, fontWeight: 400 }}>
//               Submit
//             </span>
//           </LoadingButton>
//         </Box>

//         {error && (
//           <Typography color="error" mt={2} textAlign="center">
//             {error.message || "An error occurred. Please try again."}
//           </Typography>
//         )}
//       </Card>
//     </Container>
//   );
// };

// export default LoginPage;


import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { authenticate } from "../actions/authActions";
import { Box, Card, Container, Typography } from "@mui/material";
import LoadingButton from "@mui/lab/LoadingButton";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import imge from "../assets/hom.gif";
import imgePc from "../assets/hom_pc.gif";
import { useNavigate } from "react-router-dom";
const LoginPage = () => {
  const [phoneNumber, setPhoneNumber] = useState("");
  const dispatch = useDispatch();
  const { loading, error, isAuthenticated } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  useEffect(() => {
    // Only redirect if user is actually authenticated (OTP has been verified)
    // Check localStorage for phoneNumber which is only set after successful OTP verification
    const storedPhoneNumber = localStorage.getItem("phoneNumber");
    const storedOtp = localStorage.getItem("sentOtp");
    const storedUserData = localStorage.getItem("userData");
    
    // Only redirect to home if all authentication data is present
    if (isAuthenticated && storedPhoneNumber && storedOtp && storedUserData) {
      navigate("/home");
    }
  }, [isAuthenticated, navigate]);
  const handleSubmit = () => {
    const trimmedPhoneNumber = phoneNumber.trim();
    
    // Create both formats for validation
    let phoneWithPlus, phoneWithoutPlus;
    
    if (trimmedPhoneNumber.startsWith('+')) {
      phoneWithPlus = trimmedPhoneNumber;
      phoneWithoutPlus = trimmedPhoneNumber.slice(1);
    } else {
      phoneWithPlus = '+' + trimmedPhoneNumber;
      phoneWithoutPlus = trimmedPhoneNumber;
    }
  
    if (!phoneWithoutPlus.startsWith('94')) {
      alert("Please enter a valid phone number starting with +94 or 94.");
      return;
    }
  
    dispatch(authenticate(trimmedPhoneNumber))
      .then((response) => {
        if (response.success) {
          navigate("/verify", { 
            state: { 
              phoneNumber: trimmedPhoneNumber,
              sentOtp: response.data 
            }
          });
        } else {
          const alternateFormat = trimmedPhoneNumber.startsWith('+') ? 
            trimmedPhoneNumber.slice(1) : '+' + trimmedPhoneNumber;
            
          dispatch(authenticate(alternateFormat))
            .then((altResponse) => {
              if (altResponse.success) {
                navigate("/verify", { 
                  state: { 
                    phoneNumber: trimmedPhoneNumber,
                    sentOtp: altResponse.data 
                  }
                });
              } else {
                alert("Invalid phone number. Please try again.");
              }
            });
        }
      })
      .catch((err) => console.error("Unexpected error:", err));
  };
  
  return (
    <Container
      maxWidth={false}
      disableGutters
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        backgroundColor: "#F8F9FA",
        backgroundImage: { xs: `url(${imge})`, md: `url(${imgePc})` },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
        padding: 2,
        position: "absolute",
        top: 0,
        left: 0,
        right: 0,
      }}
    >
      <Card sx={{ borderRadius: 5, boxShadow: 8, padding: 4, maxWidth: 400 }}>
        <Box textAlign="center" mb={2}>
          <Typography variant="h4" fontWeight={600}>
            Sign in
          </Typography>
          <Typography variant="subtitle1" color="textSecondary" mt={1}>
            Enter Your Registered Mobile Number
          </Typography>
        </Box>
        <Box mb={3}>
          <PhoneInput
            country={"lk"}
            value={phoneNumber}
            onChange={(phone) => setPhoneNumber(phone)}
            inputStyle={{
              width: "100%",
              paddingLeft: "60px",
              borderRadius: 3,
              fontSize: 16,
            }}
            buttonStyle={{
              position: "absolute",
              left: "9px",
              top: "50%",
              transform: "translateY(-50%)",
            }}
          />
        </Box>
        <Box>
          <LoadingButton
            onClick={handleSubmit}
            loading={loading}
            variant="contained"
            sx={{
              width: "100%",
              backgroundColor: "#0049AF",
              textTransform: "capitalize",
              borderRadius: 3,
            }}
          >
            <span style={{ color: "#fff", fontSize: 16, fontWeight: 400 }}>
              Submit
            </span>
          </LoadingButton>
        </Box>
        {error && (
          <Typography color="error" mt={2} textAlign="center">
            {error.message || "An error occurred. Please try again."}
          </Typography>
        )}
      </Card>
    </Container>
  );
};
export default LoginPage;